import { render, staticRenderFns } from "./PurchaseDeliveryValidation.vue?vue&type=template&id=d40b38be&scoped=true&"
import script from "./PurchaseDeliveryValidation.vue?vue&type=script&lang=js&"
export * from "./PurchaseDeliveryValidation.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDeliveryValidation.vue?vue&type=style&index=0&id=d40b38be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40b38be",
  null
  
)

export default component.exports